import { log } from '@domgen/shared/utils/log';
import { AddressSearchResult } from '@domgen/shared/models/services/api/getAddresses';
import { get } from './client';

export const getAddresses = async (addressLine: string): Promise<AddressSearchResult[]> => {
  try {
    const res = await get<{ addresses: AddressSearchResult[] }>(
      `/v1/addresses?addressLine=${addressLine}&maxAddresses=6`,
    );
    return res.addresses;
  } catch (err) {
    log.error({ message: 'Address search failed', data: err });
    throw err;
  }
};
